import { useTranslation } from 'react-i18next';

import { ModificationDTO, ModificationGroupDTO } from 'support/types';

import { ModificationRows } from './ModificationRows';

type ModificationLevelsProps = {
  modificationGroups?: Array<ModificationGroupDTO>;
  removeModification: (levelToModify: number, modificationPosition: number) => void;
  updateLevelModification: (levelToModify: number, modificationIndex: number, modification: ModificationDTO) => void;
  disabled?: boolean;
};

export function ModificationLevels({
  modificationGroups,
  removeModification,
  updateLevelModification,
  disabled,
}: ModificationLevelsProps) {
  const { t } = useTranslation();
  return (
    <>
      {modificationGroups?.map((modificationGroup, index) => {
        return (
          <div className="pt-1" key={index}>
            <table className="w-11/12 table-fixed text-gray-500">
              <thead className="sr-only text-left text-sm text-gray-400 sm:not-sr-only">
                <tr>
                  <th
                    scope="col"
                    className="hidden py-1 pr-2 font-normal after:ml-0.5 after:text-gray-400 after:content-['*'] sm:table-cell sm:w-full"
                  >
                    {t('webedi:modifications.type')}
                  </th>
                  <th
                    scope="col"
                    className="py-1 pr-2 font-normal after:ml-0.5 after:text-gray-400 after:content-['*'] sm:w-full"
                  >
                    {t('webedi:modifications.reason')}
                  </th>
                  <th
                    scope="col"
                    className="py-1 pr-2 font-normal after:ml-0.5 after:text-gray-400 after:content-['*'] sm:w-full"
                  >
                    {t('webedi:modifications.amount')}
                  </th>
                  <th scope="col" className="hidden py-1 pr-2 font-normal after:content-['*'] sm:table-cell sm:w-full">
                    {t('webedi:modifications.taxPercentForCharges')}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="text-sm">
                <ModificationRows
                  modifications={modificationGroup.modifications}
                  calculationLevel={modificationGroup.level}
                  removeModification={removeModification}
                  updateLevelModification={updateLevelModification}
                  disabled={disabled}
                />
              </tbody>
            </table>
          </div>
        );
      })}
    </>
  );
}
